<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12">
              <div class="row pt-3 fG white">
                <div class="col-12 pb-3">

                  <span class="naranja bold">Maestros de la parrilla</span>  es un concepto creado para consentir a nuestros clientes, donde no sólo ofrecemos los mejores cortes de carne, sino también la posibilidad de convertirte en un parrillero experto con acceso a <span class="bold">7 Master Class en vivo, 14 video cápsulas con expertos y 1 recetario digital descargable con 80 recetas</span>.



                </div>
                <div class="col-12 pb-5 text-center">
                  <div class="thumb noselect">
                    <iframe width="100%" height="560" src="https://www.youtube.com/embed/Pdbt95rrNQc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                    <!-- <div class="wrappercont">
                      <div class="tit d-flex justify-content-center align-items-center flex-row">
                        <div class="w-25">
                          <img
                            class="img-fluid px-1"
                            src="../assets/imgs/icono-video.png"
                            alt="Qué es maestros de la parrilla"
                          />
                        </div>
                        <div class="w-75">
                          <h1>¿Qué es maestros de la parrilla?</h1>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              
              <div class="row pb-5">
                <div class="col-10 offset-1 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores.png" alt="Patrocinadores">
                </div>
              </div>

              <div class="row pb-5">
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_bohemia.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_coca.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_maggi_logo.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_modelo.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_trapiche.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_tangamanga.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_chimex.png" alt="Patrocinador">
                </div>
                <div class="col-4 col-lg-3 pb-5 text-center">
                  <img class="img-fluid" src="../assets/imgs/patrocinadores/patrocinadores_bernina.png" alt="Patrocinador">
                </div>
               
                
              </div>
              

            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>

    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Footer from "../Components/Footer.vue";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      email: "",
      password: ""
    };
  },
  mounted: function() {
    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );
    AOS.init();
  },
  components: {
    "header-mx": Header,
    "footer-mx":Footer
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        matricula: this.matricula,
        password: this.password
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "home/login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //localStorage.setItem('user', res.user);
              this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              vm.$store.state.user = this.$cookie.get("useracademiadigital");
              this.$router.push(res.url);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

